/* unplugin-vue-components disabled */import script from "./BaseEmpty.vue?vue&type=script&setup=true&name=BaseEmpyt&lang=js"
export * from "./BaseEmpty.vue?vue&type=script&setup=true&name=BaseEmpyt&lang=js"

import "./BaseEmpty.vue?vue&type=style&index=0&id=65787ebb&lang=scss"

const __exports__ = script;

export default __exports__